// Angular
import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../common/stringable.decorator'
// Auth
import { AuthNoticeService } from '../../../core/auth'
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from '../../../core/_base/layout'

const KEY = 'auth-component'

@Component({
	selector: 'atyl-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
	encapsulation: ViewEncapsulation.None
})
@Stringable({
	path: 'views/pages/auth/auth',
	key: KEY,
})
export class AuthComponent implements OnInit {

	@StringableValues(KEY) strings: any
	// Public properties
	today: number = Date.now();
	headerLogo: string
	isNomade: boolean = false

	/**
	 * Component constructor
	 *
	 * @param el
	 * @param render
	 * @param layoutConfigService: LayoutConfigService
	 * @param authNoticeService: authNoticeService
	 * @param translationService: TranslationService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(
		private el: ElementRef,
		private render: Renderer2,
		private layoutConfigService: LayoutConfigService,
		public authNoticeService: AuthNoticeService,
		private translationService: TranslationService,
		private splashScreenService: SplashScreenService,
		private router: Router
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const mode = localStorage.getItem('ATYL_MODE_NOMADE')
		if (mode == 'true') {
			console.log('Nomade mode')
			this.router.navigateByUrl("/nomade_client")
		}
		this.headerLogo = this.layoutConfigService.getLogo()

		this.splashScreenService.hide()

		// load default styles
		this.loadCSS('./assets/css/style.bundle.css')
		// this.loadCSS('/style/atyl_layerGESTAMAT.css');
	}

	/**
	 * Load CSS for this specific page only, and destroy when navigate away
	 * @param styleUrl
	 */
	private loadCSS(styleUrl: string) {
		return new Promise((resolve, reject) => {
			const styleElement = document.createElement('link')
			styleElement.href = styleUrl
			styleElement.type = 'text/css'
			styleElement.rel = 'stylesheet'
			styleElement.onload = resolve
			this.render.appendChild(this.el.nativeElement, styleElement)
		})
	}
}
